import React from 'react'
import Box from '@material-ui/core/Box'
import Container from 'components/program-marketing/container'
import Typography from '@material-ui/core/Typography'
import LinkIcon from '@material-ui/icons/Link'
import makeStyles from '@material-ui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  icon: {
    verticalAlign: 'middle',
    color: theme.palette.secondary.main,
    marginRight: theme.spacing(1),
  },
}))

export const OnlineShopSection = ({ programOnlineShopUrl }) => {
  const classes = useStyles()
  return (
    <Container data-testid="online-shop-section">
      <Box mb={2}>
        <Typography variant="h3" color="primary">
          PGA Jr. League Online Shop
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="body1">
          Shop your exclusive team store with apparel and accessories from all
          of your favorite golf brands! Don’t forget to show off your new gear
          by tagging @pgajrleague on Facebook, Twitter and Instagram.
        </Typography>
        <Box mt={2}>
          <Typography
            variant="h5"
            gutterBottom
            component="a"
            href={programOnlineShopUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkIcon className={classes.icon} />
            PGA Jr. League Online Shop
          </Typography>
        </Box>
      </Box>
    </Container>
  )
}
